import React from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
// import Loading from "./Loading";
import { DataGrid } from "@mui/x-data-grid";
import AdaAlert from "./AdaAlert";
import ListHeaderBar from "./ListHeaderBar";
import EmptyDataList from "./EmptyDataList";
import "../css/dataList.sass";
import EmptyPage from "../common/EmptyPage";
import ReactLoading from "./ReactLoading";
import { IoSearch } from "react-icons/io5";

const DataList = ({
  title,
  headers,
  totalCount,
  currentPage,
  pageSize,
  rowData,
  isLoading,
  error,
  deleteMsg,
  deleteStatus,
  disabledCreate,
  emptyDataText, 
  onPageChange,
  onPageSizeChange,
  hideCreateBtn,
  onSearchChange,
  onSearchSubmit,
  searchPlaceholder,
  searchIndicator,
  onClearSearch
}) => {
  const navigate = useNavigate();
  const pathName = useLocation().pathname;

  const handleCreateOperator = () => {
    navigate(`${pathName}/create`, { replace: true });
  };

  if (isLoading) return <ReactLoading text={`Loading ${title}`} />;

  if (error) return <EmptyPage text={error} />

  return (
    <>
        {
          rowData.length === 0 && 
          <EmptyDataList text={emptyDataText} onCreate={handleCreateOperator} />
        }
        {
          rowData.length > 0 && 
            <div className="ada-operator-list-page">
              <ListHeaderBar
                title={title}
                createAction={handleCreateOperator}
                disabledCreate={disabledCreate}
                hideCreateBtn={rowData.length === 0 || hideCreateBtn}
              />
              {onSearchChange && (
                <div className='search-bar-container'>
                  <div className='search-input-wrapper'>
                    <IoSearch className='search-icon' />
                    <input
                      type='text'
                      className='search-input-field'
                      placeholder={searchPlaceholder || 'Search...'}
                      onChange={(e) => onSearchChange(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter' && onSearchSubmit) {
                          onSearchSubmit();
                        }
                      }}
                    />
                  </div>
                  <button className='search-button' onClick={onSearchSubmit}>
                    Search
                  </button>
                </div>
              )}
              
              {/* Search Result Indicator */}
              {searchIndicator && (
                <div style={{ 
                  padding: '8px 16px', 
                  color: '#1976d2', 
                  borderRadius: '4px',
                  marginBottom: '10px',
                  marginLeft: '20px',
                  marginTop: '30px',
                  fontSize: '12px',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  width: '80%', // Match ada-operator-list-container width
                  boxSizing: 'border-box',
                  gap: '10px'
                }}>
                  <span style={{ 
                    color: '#212529',
                    marginRight: '12px',
                    flexShrink: 0 // Prevent text from shrinking
                  }}>
                    Showing results for: <strong style={{ color: '#212529' }}>"{searchIndicator}"</strong>
                  </span>
                  {onClearSearch && (
                    <button 
                      onClick={onClearSearch}
                      style={{
                        padding: '4px 12px',
                        backgroundColor: '#fff',
                        border: '1px solid #1976d2',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#1976d2',
                        alignSelf: 'flex-start' // Align to top
                      }}
                    >
                      clear
                    </button>
                  )}
                </div>
              )}
              <div className="ada-operator-list-container">
                <DataGrid
                  key={`${totalCount}-${currentPage}-${rowData.length}`}
                  rows={rowData}
                  columns={headers}
                  onPageChange={(newPage) => onPageChange(newPage)}
                  onPageSizeChange={(newPageSize) => onPageSizeChange(newPageSize)}
                  rowsPerPageOptions={[10, 15, 20]}
                  rowCount={totalCount}
                  paginationMode="server"
                  initialState={{
                    // ...rowData.initialState,
                    pagination: {
                      pageSize: pageSize,
                      page: currentPage - 1
                    },
                  }}
                  scrollbarSize={2}
                  scrollArea--right={{
                    backgroundColor: 'transparent',
                  }}
                  getRowId= {(row) => row.id}
                />
              </div>
              {deleteMsg && <AdaAlert message={deleteMsg} type={deleteStatus} />}
            </div>
        }
    </>
  );
};

export default DataList;
